import React, { useState } from "react";
import {
  Divider,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircleOutlined";
import LogoutIcon from "@mui/icons-material/LogoutOutlined";
import apiFetch from "../../utils/apiFetch";

// Signs the user out, then clears client-side auth state and returns to login.
// Mirrors the legacy navbar logout: hit Devise sign_out, then clean up regardless.
async function handleLogout() {
  try {
    await apiFetch("/users/sign_out", { method: "DELETE" });
  } catch (e) {
    // fall through to client-side cleanup regardless
  }
  try {
    window.localStorage.removeItem("tk");
    window.localStorage.removeItem("current_school_slug");
  } catch (e) {
    // ignore storage errors (private mode, etc.)
  }
  window.location.replace("/login");
}

export default function UserMenu({ staff }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  if (!staff) return null;

  const fullName = `${staff.first_name ?? ""} ${staff.last_name ?? ""}`.trim();
  const handleOpen = (e) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  // Sends Devise reset-password instructions to the staff login email, then
  // routes to the confirmation screen. Same behavior as the legacy navbar.
  const handleChangePassword = async () => {
    handleClose();
    try {
      await apiFetch("/users/password", {
        method: "POST",
        body: JSON.stringify({ email: staff.school_email }),
      });
      window.location.assign("/forgot-password?isSent=true");
    } catch (e) {
      window.location.reload();
    }
  };

  return (
    <>
      <IconButton aria-label="Account menu" onClick={handleOpen}>
        <AccountCircleIcon sx={{ color: "#00000080" }} />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem disabled sx={{ "&.Mui-disabled": { opacity: 1 } }}>
          <Typography sx={{ fontWeight: 600, color: "#000000" }}>
            {fullName}
          </Typography>
        </MenuItem>
        <Divider />
        <MenuItem
          role="menuitem"
          aria-label="Update password"
          onClick={handleChangePassword}
        >
          Update Password
        </MenuItem>
        <MenuItem role="menuitem" aria-label="Logout" onClick={handleLogout}>
          <ListItemIcon>
            <LogoutIcon fontSize="small" sx={{ color: "#00000080" }} />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
    </>
  );
}
